const stageThreeParam = retailer.stageThreeParam;
const spinner = $('.loading-spinner-img');
const chartDOM = $('.game-chart-canvas');
const retailerStore = require('./retailer.student.store.js');
const Chartjs = require('../../node_modules/chart.js/dist/Chart.js');
Chartjs.defaults.global.defaultFontSize = 12;
Chartjs.defaults.global.defaultFontColor = '#000';
Chartjs.defaults.global.elements.line.borderCapStyle = 'round';
// example data points:
// data: [{y: 2000, x: 1}, {y: 1900, x: 2}, {y: NaN, x: 3}],
// data: [{y: NaN, x: 1}, {y: 0, x: 2}, {y: 1800, x: 3}],
let chartOptions = {
    type: 'line',
    data: {
        labels: Array(stageThreeParam.NUMBER_OF_WEEKS).map(function(_, i) { return i+1; }),
        datasets: [
            {
                pointStyle: 'circle',
                pointBackgroundColor: 'rgba(214, 21, 21, 1)',
                backgroundColor: 'rgba(214, 21, 21, 0.2)',
                borderColor: 'rgba(214, 21, 21, 1)',
                lineTension: 0,
                label: stageThreeParam.PRICE_LABEL[0],
            }, 
            {
                pointStyle: 'circle',
                pointBackgroundColor: 'rgba(214, 21, 21, 1)',
                backgroundColor: 'rgba(214, 21, 21, 0.3)',
                borderColor: 'rgba(214, 21, 21, 1)',
                lineTension: 0,
                label: stageThreeParam.PRICE_LABEL[1],
            }, 
            {
                pointStyle: 'circle',
                pointBackgroundColor: 'rgba(214, 21, 21, 1)',
                backgroundColor: 'rgba(219, 77, 77, 0.5)',
                borderColor: 'rgba(214, 21, 21, 1)',
                lineTension: 0,
                label: stageThreeParam.PRICE_LABEL[2]
            },
            {
                pointStyle: 'circle',
                pointBackgroundColor: 'rgba(214, 21, 21, 1)',
                backgroundColor: 'rgba(214, 21, 21, 0.5)',
                borderColor: 'rgba(214, 21, 21, 1)',
                lineTension: 0,
                label: stageThreeParam.PRICE_LABEL[3]
            }
        ]
    },
    options: {
        legend: {
            display: false
        },
        scales: {
            yAxes: [{
                scaleLabel: {
                    labelString: 'Inventory on Hand',
                    display: true,
                    fontSize: 14,
                    fontStyle: 'bold'
                },
                type: 'linear',
                stacked: true,
                ticks: {
                    min: 0,
                    max: stageThreeParam.INITIAL_INVENTORY,
                    fixedStepSize: 200
                },
                beginAtZero: true,
            }],
            xAxes: [{
                scaleLabel: {
                    labelString: 'Week',
                    display: true,
                    fontSize: 14,
                    fontStyle: 'bold'
                },
                gridLines: {
                    display: false
                },
                display: true,
                ticks: {
                    min: 1,
                    max: stageThreeParam.NUMBER_OF_WEEKS+1,
                    fixedStepSize: 1
                },
                type: 'linear',
                position: 'bottom',
                id: 'x-axis-0'
            }],
        },
        maintainAspectRatio: false
    }
};
let gameChart;

function addDataPointToDatasetAndZeroToOtherDatasets(datasetIdx, x, y) {
    gameChart.data.datasets.forEach((dataset, idx) => {
        if (idx === datasetIdx)
            dataset.data.push({x, y});
        else
            dataset.data.push({x, y: NaN});
    });
}
function resetDatasets() {
    gameChart.data.datasets.forEach(el => { el.data = [] });
}
function processPriceTransitionPoints() {
    // e.g. if price is 0,0,0,1,1,2,2
    // at week 1, 2, the dataset for price idx 1 will be NaN
    // at week 3, it's transition point from price idx 0 to price idx 1
    // so data point will not be NaN, but 0 
    gameChart.data.datasets.forEach(dataset => {
        for (let i=0; i<dataset.data.length; i++) {
            // if it's the first non-NaN datapoint and not first datapoint (to guard dataset[0]) 
            if (!isNaN(dataset.data[i].y)) {
                if (i !== 0)
                    dataset.data[i-1].y = 0;
                break;
            }
        }
    });
}
retailer.initChart = function() {
    gameChart = new Chartjs(chartDOM, chartOptions);
    spinner.hide(300);
};
retailer.drawWithState = function(clientRoundData) {
    if (!gameChart)
        return console.log('WARNING: no gameChart when called');
    if (!clientRoundData)
        return console.log('WARNING: no rounddata');
    resetDatasets();
    // at week one conceptually we have full inventory
    addDataPointToDatasetAndZeroToOtherDatasets(0, 1, stageThreeParam.INITIAL_INVENTORY);
    for (let i=0; i<stageThreeParam.NUMBER_OF_WEEKS; i++) {
        if (clientRoundData.weeks[i] === undefined)
            break;
        let price = clientRoundData.priceActions[i] !== undefined ? clientRoundData.priceActions[i] :
            clientRoundData.priceActions[clientRoundData.priceActions.length-1];
        addDataPointToDatasetAndZeroToOtherDatasets(price, i+2, clientRoundData.weeks[i].inventory);
        if (clientRoundData.weeks[i].inventory === 0)
            break;
    }
    processPriceTransitionPoints();
    gameChart.update(0, true);
};


// WEBPACK FOOTER //
// ../public/js/retailer.student.chart.js